import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';
import { SnapshotHistorySettingWithSnapshot } from 'types/models/SnapshotHistorySetting';

export const getAllSnapshotHistorySettings = async (): Promise<
  SnapshotHistorySettingWithSnapshot[]
> => {
  const { data }: { data: SnapshotHistorySettingWithSnapshot[] } =
    await axios.get(`/api/snapshots/history/settings`);
  return data as SnapshotHistorySettingWithSnapshot[];
};

type QueryFnType = typeof getAllSnapshotHistorySettings;

type UseAllSnapshotHistorySettingsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useAllSnapshotHistorySettings = ({
  config,
}: UseAllSnapshotHistorySettingsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['allSnapshotHistorySettings'],
    queryFn: () => getAllSnapshotHistorySettings(),
    ...config,
  });
};
